// extracted by mini-css-extract-plugin
export default {"profilePage":"profilePage__profilePage--Q8P4t","asideContainer":"profilePage__asideContainer--rK6dk","mainContainer":"profilePage__mainContainer--FroOL"};